import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import { FlexCol, FlexContainer, FlexRow, Icons } from 'sarsaparilla';
import TextInput from '../../../../ui-lottery/src/components/inputs/TextInput';
import { getUserSearchErrors, getUserSearchTerm } from '../../reducers/userSearch';
import { fetchAccount } from '../../actions/account';
import { saveUserSearchTerm } from '../../actions/userSearch';

import * as styles from './UserAdminPage.scss';

const propTypes = {
  value: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string),
  saveSearch: PropTypes.func.isRequired, // This should save and validate the term returning true if validation passed.
  fetchAccount: PropTypes.func.isRequired
};

const defaultProps = {
  value: '',
  errors: []
};

export class SearchForm extends PureComponent {
  constructor(props) {
    super(props);

    this.fetchAccount = debounce(this.fetchAccount.bind(this), 350);
    this.saveTerm = this.saveTerm.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  saveTerm(term) {
    if (this.props.saveSearch(term)) {
      this.fetchAccount(term);
    }
    else {
      this.fetchAccount.cancel();
    }
  }

  // By debouncing this method and not the action we can handle the returned Promise
  // however we need
  fetchAccount(terms) {
    this.props.fetchAccount({ query: terms })
      .catch(() => {}); // Ignore errors
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      this.fetchAccount.flush();
    }
  }

  render() {
    const { value, errors } = this.props;
    return (
      <FlexContainer>
        <FlexRow>
          <FlexCol>
            <TextInput
              id="user-search-string"
              value={value}
              iconLeft={Icons.IconSearch}
              label="User Search"
              onChange={this.saveTerm}
              onKeyPress={this.handleKeyPress}
              placeholder="User Email" />
            {this.props.errors.length === 0 ? null :
              <ul className={styles.errors}>
                {errors.map((error, i) => (
                  <li key={`error-${i}`}>
                    {error}
                  </li>
                ))}
              </ul>
            }
          </FlexCol>
        </FlexRow>
      </FlexContainer>
    );
  }
}

SearchForm.propTypes = propTypes;
SearchForm.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  value: getUserSearchTerm(state),
  errors: getUserSearchErrors(state)
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  saveSearch: saveUserSearchTerm,
  fetchAccount
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SearchForm);
